import axios from 'axios'
import { trackPromise } from 'react-promise-tracker';
import * as CommonVariables from '../../Common/CommonVariables'

// Wrappers around our backend's HVTAPIIntegration controller, which proxies
// the TruHealth (HVT) API - see "TruHealth (HVT) API - Consolidated Reference
// (UAT v3.0.5)" - so the Bearer token never has to live in the browser.
// All endpoints below are POST per the backend's Swagger definition.

const BASE = 'HVTAPIIntegration';

// 2. Get_Serviceable_Pincode -> all serviceable pincodes grouped by org
export const GetServiceablePincode = async () => {
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `${BASE}/GetServiceablePincode`, JSON.stringify({}), CommonVariables.API_HEADER)).then(response => response);
    return result;
}

// 3. Get_Circle_Location_Using_Pincode -> resolve pincode to serviceable locations
export const GetCircleLocationUsingPincode = async (pincode) => {
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `${BASE}/GetCircleLocationUsingPincode`, JSON.stringify({ Pincode: pincode }), CommonVariables.API_HEADER)).then(response => response);
    return result;
}

// 4. Get_Phlebo_Available_Location_Decrypt -> available slots for a location/date
export const GetPhleboAvailableLocationDecrypt = async (data) => {
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `${BASE}/GetPhleboAvailableLocationDecrypt`, JSON.stringify(data), CommonVariables.API_HEADER)).then(response => response);
    return result;
}

// 5. GetAvailabilityPhlebo -> block phlebo for a patient/slot (5 min hold)
export const GetAvailabilityPhlebo = async (data) => {
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `${BASE}/GetAvailabilityPhlebo`, JSON.stringify(data), CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GenerateUniquePatientId = async () => {
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `${BASE}/GenerateUniquePatientId`, JSON.stringify({}), CommonVariables.API_HEADER)).then(response => response);
    return result;
}

// 6. New Registration -> confirm booking for the first patient
export const NewRegistration = async (data) => {
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `${BASE}/NewRegistration`, JSON.stringify(data), CommonVariables.API_HEADER)).then(response => response);
    return result;
}

// 7. Add New Registration [Multi Patient] -> add more patients to same booking
export const AddNewRegistrationMultiPatient = async (data) => {
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `${BASE}/AddNewRegistrationMultiPatient`, JSON.stringify(data), CommonVariables.API_HEADER)).then(response => response);
    return result;
}

// 8. Cancel Schedule -> cancel a booking
export const CancelSchedule = async (bookingId, cancellationReason) => {
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `${BASE}/CancelSchedule`, JSON.stringify({
        BookingID: bookingId,
        CancellationReason: cancellationReason,
        UserId: null,
        PartnerCode: null,
    }), CommonVariables.API_HEADER)).then(response => response);
    return result;
}

// 9. Save Reschedule -> reschedule an existing booking
export const SaveReschedule = async (data) => {
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `${BASE}/SaveReschedule`, JSON.stringify(data), CommonVariables.API_HEADER)).then(response => response);
    return result;
}

// 10. Order Status -> booking/visit status + VID
export const OrderStatus = async (bookingId) => {
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `${BASE}/OrderStatus`, JSON.stringify({ BookingId: bookingId }), CommonVariables.API_HEADER)).then(response => response);
    return result;
}

// Get_Salutation_List -> salutation options per gender
export const GetSalutationList = async () => {
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `${BASE}/GetSalutationList`, JSON.stringify({}), CommonVariables.API_HEADER)).then(response => response);
    return result;
}

// Get_Registration_List -> paged/searchable list for the HVT list page
export const GetRegistrationList = async (data) => {
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `${BASE}/GetRegistrationList`, JSON.stringify(data), CommonVariables.API_HEADER)).then(response => response);
    return result;
}

// Get_Registration_Details_By_Id -> full detail view for the "View" action on the list page
export const GetBookingDetailsByBookingId = async (bookingId) => {
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `${BASE}/GetBookingDetailsByBookingId`, JSON.stringify({ BookingId: bookingId }), CommonVariables.API_HEADER)).then(response => response);
    return result;
}

// Get_Frequent_Test_List -> most commonly booked tests, shown as quick-add suggestions
export const GetFrequentTestList = async (payload) => {
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `${BASE}/GetFrequentTestList`, JSON.stringify(payload), CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const getGroupSiblings = async (bookingId) => {
    const payload = {
        SearchText: bookingId,
        SortColumn: "VisitDate",
        SortDirection: "desc",
        Skip: 0,
        Take: 50,
        StartDate: "2000-01-01T00:00:00",
        EndDate: "2100-01-01T00:00:00",
    };
    const { data } = await GetRegistrationList(payload);
    const rows = data?.IsSuccess && data?.Data?.RegistrationList?.length ? data.Data.RegistrationList : [];
    const groupId = `G${bookingId}`;
    return rows
        .filter((r) => r.BookingId === bookingId || r.GroupId === groupId)
        .map((r) => ({ BookingId: r.BookingId, PID: r.PatientId }));
}

export const UniversalSearchTestDetailByTestCode = async (data) => {
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `HVTAPIIntegration/UniversalSearchTestDetailByTestCode`, JSON.stringify(data), CommonVariables.API_HEADER)).then(response => response);
    return result;
}
